import Cookies from 'cookie-universal';

import { IntercomService } from '@/modules/shared/infrastructure/services/IntercomService';
import { COOKIES } from '@/services/constants';

export default {
  data() {
    return {
      intercomService: null,
    };
  },
  created() {
    this.intercomService = new IntercomService({ intercomAppID: this.$config.intercomAppID });
  },
  methods: {
    setupIntercom() {
      if (window.Intercom) {
        const isManagePageOrChildren = this.$route.path.startsWith('/manage');

        if (['/login', '/contact'].includes(this.$route.path) || isManagePageOrChildren) {
          const cookies = Cookies();
          const storedUserAttrs = cookies.get(COOKIES.userAttrs);

          const desiredAttrs = isManagePageOrChildren
            ? {
                email: storedUserAttrs?.email || this.userSubscription?.userAttrs?.email,
                userId:
                  storedUserAttrs?.uuid || this.userSubscription?.uuid || this.userSubscription?.userAttrs?.intercomId,
              }
            : { email: undefined, userId: undefined };

          this.intercomService.boot(desiredAttrs);
        }
      }
    },

    showIntercomWidget() {
      const cookies = Cookies();
      const storedUserAttrs = cookies.get(COOKIES.userAttrs);
      const email = storedUserAttrs?.email;
      const userId = storedUserAttrs?.uuid;

      if (email && userId) {
        this.intercomService.boot({ email, userId });
      } else {
        this.intercomService.update();
      }
    },
  },
};
